import React from 'react'
import EmbedNode from '../EmbedNode'

export default function BoxNode({id,data,selected,...props}) {
    return (
        <EmbedNode domain='box.com' transformUrl={(url) => url.includes('embed')? url:url.replace('/app.','/cloud.app.').replace('/s/','/embed/s/')} className='' text='Box Link' id={id} data={data} selected={selected} {...props} />
    )
}